export async function readSession(client, apiBase, options = {}) {
  const maxAttempts = Math.max(1, Number(options.maxAttempts) || 3);
  const delay = options.delay || ((milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds)));

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    try {
      const { data } = await client.get(`${apiBase}/api/auth/me`, { withCredentials: true, timeout: 10000 });
      if (data.authenticated) return data.user;
      if (attempt === maxAttempts - 1) return null;
    } catch (error) {
      if (error.response?.status === 401) return null;
      if (attempt === maxAttempts - 1) throw error;
    }

    await delay(400 * (attempt + 1));
  }

  return null;
}
